module.exports = __webpack_public_path__ + "static/media/NisaDoclock.9d17b100.png";